import { Box } from '@mui/material';
import { memo } from 'react';
import DnDBasePlusNavItem from './DnDBasePlusNavItem';
import { PlusNavObj } from '../types';

interface AppSearchResultsProps {
  searchResults: PlusNavObj[];
  handleItemClick: (event: React.SyntheticEvent<HTMLElement>, item: PlusNavObj) => void;
  handlePinToggle: (item: PlusNavObj) => void;
  pinnedApps: string[];
  editMode: boolean;
}

const AppSearchResults = memo(
  ({
    searchResults,
    handleItemClick,
    handlePinToggle,
    pinnedApps,
    editMode,
  }: AppSearchResultsProps) => {
    return (
      <Box
        id="plus-button-search-results-grid"
        data-testid="plus-button-search-results-grid"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(1, 1fr)',
          gap: 1,
        }}
      >
        {searchResults.map((item) => (
          <DnDBasePlusNavItem
            key={item.key}
            id={`plus-button-search-item-${item.key}`}
            navItem={item}
            handleOnClick={(event) => handleItemClick(event, item)}
            asIcon={false}
            handlePinToggle={handlePinToggle}
            pinnedApps={pinnedApps}
            hidePin={!editMode}
            href={item?.path}
            hidden={item?.hidden}
          />
        ))}
      </Box>
    );
  },
);

AppSearchResults.displayName = 'AppSearchResults';
export default AppSearchResults;
